export default "__VITE_ASSET__BcCFhebo__"